<template>
<div>
    <div class="block-container" ref="blockContain" :style="layerStyle">
    <div class="temp-block" ref="tempBlock"></div>
   <!-- <div v-for = "(block,index) in eventData.blocks" :key = "block.title" class="highlight-container" >-->

      <TetrisPiece
      v-for = "(block,index) in eventData.blocks" 
      :style="{order:index}"
      :key = "block.title"
      :title = "block.title"
      :description="block.description"
      :question="block.question"
      :photo-name="block.photoName"
      :answers="block.answers"
      :squareSize="squareSize"
      :getParentBoundingRect="getParentBoundingRect"
      :all-grid-bounding-rects="allGridBoundingRects"
      :event-index="eventIndex"
      :isLockedInit="block.isLockedInit"
      :pieceType="block.pieceType"
      :grid-location="block.gridLoc"
      :grid-rotation="block.gridRot"
      :event-reached="eventReached"
      :is-selected="index===selectedBlock"
      :credit="block.credit"
      :photo-width="block.photoWidth"
      @piece-placed = "registerPiecePlaced(index)"
      @toggle-grid-highlight = "toggleGridHighlight(index)"
      @toggle-grid-hovering = "toggleGridHovering"
      ></TetrisPiece>
       <!--
        <div v-if="index===selectedBlock"  class="highlight" :style="highlightStyle"></div>
    -->
    <!--</div>-->

    </div>
    <AchievementPopup
        :visible="achievementVisible"
        :title = "eventData.title"
        :panel-data="eventData.achievementPanels"
        @close="closeAchievement"
        @answered-correct="closeAchievement"
    ></AchievementPopup>
</div>

</template>

<script>

import AchievementPopup from './AchievementPopup.vue';
import TetrisPiece from './TetrisPiece.vue';

export default{
    name:'TetrisPieceContainer',
    components:{
        TetrisPiece,
        AchievementPopup,
    },
    mounted(){
        window.addEventListener('keydown',this.handleKeyDown)
    },
    props: {
        squareSize: {
            type: Number,
            required: true,
        },

        allGridBoundingRects:{
            type:Array,
            default:()=>[]
        },
        eventIndex:{
            type:Number,
            default:0
        },
        eventData:{
            type:Object,
            required:true
        },
        allowInput:{
            type:Boolean,
            default:true
        }
    },
    methods:{
        registerPiecePlaced(index){
            this.numBlocksPlaced++;
            console.log("placed piece:", index)
            this.blocksPlaces[index]=true
            if(this.numBlocksPlaced == this.eventData.blocks.length){
                //wait for block to slide into place before moving event down
                setTimeout(
                    ()=>{
                        this.$emit('event-reached')
                        this.eventReached=true
                        this.$refs.blockContain.style.transform = `translateY(${this.numBlocksPlaced*this.squareSize}px)`
                    },
                    1500
                )
                //wait to move event down before achievement popup
                setTimeout(
                    ()=>{
                        this.achievementVisible=true;
                    },
                    3000
                )

            }
            else{
            if(this.selectedBlock!=-1){
                setTimeout(()=>{this.incrementSelected()},100)
            }
            }
        },
        getParentBoundingRect(){
            return this.$refs.blockContain.getBoundingClientRect()
        },
        closeAchievement(){
            this.achievementVisible=false;
            this.$emit('achievement-finished')

            //need to request updates on grid location as it slid down after completing this event
            //and css transforms dont cause vue updates :(
            this.$emit('update-grid-request')
        },
        toggleGridHighlight(index){
            this.$emit('toggle-grid-highlight')
            if(this.holdingBlock){
                this.$refs.tempBlock.style.order = this.eventData.blocks.length
                this.$refs.tempBlock.style.height = '0px'
            }
            else{
                this.$refs.tempBlock.style.order = index
                if(this.eventData.blocks[index].pieceType=='i'){
                    //height of block +25px for margin
                    this.$refs.tempBlock.style.height = `${this.squareSize+25}px`
                }
                else{
                    //height of block +25px for margin
                    this.$refs.tempBlock.style.height = `${this.squareSize*2+25}px`
                }
            }
            this.holdingBlock = !this.holdingBlock
        },
        toggleGridHovering(){
            this.$emit('toggle-grid-hovering')
        },

        incrementSelected(){
            this.selectedBlock++;
            if(this.selectedBlock>=this.eventData.blocks.length){
                this.selectedBlock=0
            }
            while((this.selectedBlock in this.blocksPlaces)){
                this.selectedBlock++;
                if(this.selectedBlock>=this.eventData.blocks.length){
                    this.selectedBlock=0
                }
            }
            console.log(this.selectedBlock)
        },
        decrementSelected(){
            this.selectedBlock--;
            if(this.selectedBlock<0){
                this.selectedBlock=this.eventData.blocks.length-1
            }
            while((this.selectedBlock in this.blocksPlaces)){
                this.selectedBlock--;
                if(this.selectedBlock<0){
                    this.selectedBlock=this.eventData.blocks.length-1
                }
            }
            console.log(this.selectedBlock)
        },
        handleKeyDown(e){
            if(this.holdingBlock || !this.allowInput){return}
            if(this.numBlocksPlaced == this.eventData.blocks.length){return}
            switch(e.key){
                case "ArrowUp":
                case "w":
                case "PageUp":
                    this.decrementSelected()
                    break;
                case "ArrowDown":
                case "s":
                case "PageDown":
                    this.incrementSelected()
                    break;
            }
        },
        

    },
    computed:{
        layerStyle(){
            return {
                zIndex:10 + (10*this.eventIndex)
            }
        },
        highlightStyle(){
            if(this.eventData.blocks[this.selectedBlock].pieceType=='i'){
                    return  {height:`${this.squareSize}px`}
                }
                else{
                    return{height: `${this.squareSize*2}px`}
                }
        }
    },
    data(){
        return {
            numBlocksPlaced:0,
            achievementVisible:false,
            holdingBlock:false,
            eventReached:false,
            selectedBlock:-1,
            blocksPlaces:{}
        }
    }



}

</script>

<style scoped>
.block-container {
  position:relative;
  display:flex;
  flex-flow: column nowrap;
  align-content: center;
  align-items:center;

  z-index:10;
  width: 100%;
  transition: transform 2.5s ease;
  padding-top:3rem;
  z-index:-1;


}
.temp-block{
    width:100%;
    height:0%;
    order:50;
}
.highlight{
    background-color: rgba(200,200,200,0.3);
    width:100%;
    position:absolute;
    
    left:0px;
}
</style>